import { render, staticRenderFns } from "./PoemView.vue?vue&type=template&id=d96a4326&scoped=true&"
import script from "./PoemView.vue?vue&type=script&lang=js&"
export * from "./PoemView.vue?vue&type=script&lang=js&"
import style0 from "./PoemView.vue?vue&type=style&index=0&id=d96a4326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96a4326",
  null
  
)

export default component.exports